module.exports = __webpack_public_path__ + "img/Screenshot_20200107_155732.815fab86.png";